import api, { handleError } from "../index";
import { getSessionGuid } from "src/lib/tracking-cookies";

export function updateEngravingService({ engraving = "", apiToken }) {
  return api({
    method: "put",
    url: `/subscription/engraving`,
    data: { engraving: engraving.trim(), session_guid: getSessionGuid() },
    headers: {
      ...api.defaults.headers,
      Authorization: `Bearer ${apiToken}`,
    },
  })
    .then((response = {}) => {
      return { error: null, data: response.data.data };
    })
    .catch((error) => {
      const errorPayload = handleError(error);
      return {
        ...errorPayload,
        data: null,
      };
    });
}
